import { Dispatch } from 'react'

import { doc, getDoc } from 'firebase/firestore'

import { Routines } from '../../components/users/professors/Students/RoutineSection'
import { AudioRef, NewLog } from '../../types'
import { firestore } from '../firebaseConfig'

const filterExercisesByCategory = (
  logs: NewLog[],
  category: string,
): { title: string; url: string; routine: string | null }[] => {
  return logs.flatMap((log) => {
    if (category === 'Ejercicios Especiales') {
      if (log.audio) {
        const audios: AudioRef[] = Array.isArray(log.audio)
          ? log.audio
          : [log.audio]

        return audios
          .filter((a) => a?.title?.trim().length > 0)
          .map((a) => ({
            title: a.title,
            url: a.url,
            routine: category,
            logUID: log.uid,
            visibility: true,
          }))
      } else {
        return []
      }
    } else {
      return log.exercises
        .filter((exercise) => exercise.category.includes(category))
        .map((exercise) => {
          if (exercise.exercise.title.length > 0) {
            return {
              title: exercise.exercise.title,
              url: exercise.exercise.url,
              routine: exercise.routine,
              logUID: log.uid,
              visibility: exercise.visibility ?? true,
            }
          } else {
            return null
          }
        })
        .filter((exercise) => exercise !== null)
    }
  })
}

export const getRoutinesNames = async (
  studentLogs: NewLog[] | null,
  setExerByCat: Dispatch<React.SetStateAction<Routines[] | null>>,
) => {
  try {
    const docRef = doc(firestore, 'lists', 'trainingType')

    const docSnapshot = await getDoc(docRef)

    if (docSnapshot.exists() && studentLogs) {
      const categories = docSnapshot.data().items

      const filteredItems = categories.map((item: string) => {
        return {
          category: item,
          content: filterExercisesByCategory(studentLogs, item),
        }
      })

      setExerByCat(filteredItems)
    }
  } catch (error) {
    console.error('Error accediendo a la lista de entrenamiento:')
  }
}
